import { Component, Input } from '@angular/core';
import {
  NavController,
  NavParams,
  ModalController,
  App,
  Events
} from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { LoaderServiceProvider } from '../../providers/loader-service/loader-service';
import { ToastServiceProvider } from '../../providers/toast-service/toast-service';
import { MessageFactory } from '../../app/factories/message.factory';
import { RequestServiceProvider } from '../../providers/request-service/request-service';
import { ReadFile } from 'ngx-file-helpers';
import * as _ from 'lodash';

@Component({
  selector: 'add-ask',
  templateUrl: 'add-ask.html'
})
export class AddAskComponent {
  @Input() mode: string; // add and first

  public items: any = [];
  picked: ReadFile;
  cardSelected;
  messageValidValues;
  selected;
  selectedItem;
  cardsValues = [];
  lubbuForm: FormGroup;
  unPlashImage: string = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastService: ToastServiceProvider,
    public loaderService: LoaderServiceProvider,
    public messageFactory: MessageFactory,
    public requestService: RequestServiceProvider,
    public modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private app: App,
    public events: Events
  ) {
    this.getCatalogsSuggestions();

    this.lubbuForm = this.formBuilder.group({
      name: ['', Validators.required],
      note: ['', Validators.required]
    });
  }

  /**
   * Get profile information
   *
   * @memberof AddAskComponent
   */
  getCatalogsSuggestions(): void {
    this.loaderService.showLoader();

    this.requestService.getSuggestedItems().subscribe(
      data => {
        this.loaderService.dismissLoader();
        this.items = data;
      },
      () => {
        this.loaderService.dismissLoader();
        this.toastService.show(this.messageFactory.getMessage('BACKEND_ERROR'));
      }
    );
  }

  /**
   *Submit form
   *
   * @memberof AddAskComponent
   */
  submit() {
    if (
      this.lubbuForm.valid &&
      (_.get(this.picked, 'content') || this.unPlashImage !== '')
    ) {
      const params = {
        photo: _.get(this.picked, 'content') || this.unPlashImage,
        amount: this.lubbuForm.get('amount').value,
        title: this.lubbuForm.get('name').value,
        comment: this.lubbuForm.get('note').value,
        store: this.selected
      };
      this.loaderService.showLoader();
      this.requestService.createAsk(params).subscribe(
        data => {
          this.loaderService.dismissLoader();
          this.events.publish('fulfill-item');
          this.app.getRootNav().setRoot('TabsPage');
        },
        err => {
          this.loaderService.dismissLoader();
          if (err.error.error) {
            this.toastService.show(err.error.error);
          } else {
            this.toastService.show(
              this.messageFactory.getMessage('BACKEND_ERROR')
            );
          }
        }
      );
    } else {
      this.setErrors();
    }
  }

  /**
   * Set submit errors to show on toast message
   *
   * @memberof AddAskComponent
   */
  setErrors() {
    const message = [];

    if (!_.get(this.picked, 'content') && this.unPlashImage === '') {
      message.push('Image');
    }

    if (this.lubbuForm.get('name').value === '') {
      message.push('Name');
    }

    if (this.lubbuForm.get('note').value === '') {
      message.push('Note');
    }

    if (message.length !== 0) {
      this.toastService.show(`Missing: ${message.join(' - ')}`);
    }
  }

  /**
   * Select gift card handler
   *
   * @memberof AddAskComponent
   */
  selectGiftCard(event) {
    if (
      this.lubbuForm.valid &&
      (_.get(this.picked, 'content') || this.unPlashImage !== '')
    ) {
      const item = {
        name: this.lubbuForm.get('name').value,
        note: this.lubbuForm.get('note').value,
        photo: _.get(this.picked, 'content') || this.unPlashImage
      };
      let modal = this.modalCtrl.create(
        'AddGiftCardsPage',
        { item: Object.assign({}, item) },
        { cssClass: 'add-gift-card-modal' }
      );

      this.cardSelected = null;
      this.cardsValues = [];

      modal.onDidDismiss(data => {
        if (data) {
          let modalConfirmation = this.modalCtrl.create('ConfirmModalPage', {
            title: 'Asked and done!',
            descriptionStyle: 'ask'
          });
          modalConfirmation.present();

          modalConfirmation.onDidDismiss(data => {
            this.app.getRootNav().setRoot('TabsPage');
          });
        }
      });
      modal.present();
    } else {
      this.setErrors();
    }
  }

  /**
   * Gift card selection
   *
   * @param {Object} id
   * @memberof AddAskComponent
   */
  selectGiftCardValue(item): void {
    this.selected = item.utid;
    this.selectedItem = item;

    this.lubbuForm.patchValue({
      amount: item.amount || item.value
    });
  }

  /**
   * Open Modal add Image
   *
   * @memberof AddAskComponent
   */
  searchPhoto() {
    let modal = this.modalCtrl.create(
      'UnsplashImagePage',
      {},
      {
        cssClass: 'unsplash-modal'
      }
    );
    modal.onDidDismiss(data => {
      if (data) {
        // unPlash image
        if (typeof data === 'string') {
          this.unPlashImage = data;
          this.picked = null;
        } else {
          // from file or taken
          this.picked = data;
          this.unPlashImage = '';
        }
      }
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/add-ask/add-ask.ts